import React from 'react';
import { MenuItem, Button, Select } from '@mui/material';
import { Cancel, Start } from '@mui/icons-material';
import Grid from '@mui/material/Grid';

function Logic(props) {
  return (
    <Select
      style={{
        width: '100%',
        backgroundColor: 'var(--mui-palette-action-hover)',
        borderRadius: '4px',
        height: '36px',
        color: 'var(--mui-palette-text-secondary)',
        textAlign: 'center',
      }}
      name="selectType"
      disableUnderline
      variant="standard"
      labelId="demo-simple-select-outlined-label"
      className="dropdown-mat selectStandard"
      value={props.value}
      onChange={event => {
        props.onChange(event.target.value);
      }}
    >
      <MenuItem value={'or'}> OR </MenuItem>
      <MenuItem value={'and'}> AND </MenuItem>
    </Select>
  );
}

function OutputType(props) {
  return (
    <Select
      style={{
        width: '100%',
        backgroundColor: 'var(--mui-palette-action-hover)',
        borderRadius: '4px',
        height: '36px',
        color: 'var(--mui-palette-text-secondary)',
      }}
      name="selectType"
      disableUnderline
      variant="standard"
      labelId="demo-simple-select-outlined-label"
      className="dropdown-mat selectStandard"
      displayEmpty
      value={props.value}
      onChange={event => {
        props.onChange(event.target.value);
      }}
    >
      <MenuItem value="" disabled>
        {' '}
        Select type{' '}
      </MenuItem>
      <MenuItem value={'TEXT'}> Text </MenuItem>
      <MenuItem value={'NUMBER'}> Number </MenuItem>
    </Select>
  );
}

function SelectFuc(props) {
  return (
    <React.Fragment>
      <Select
        // native
        style={{
          width: '100%',
          backgroundColor: 'var(--mui-palette-action-hover)',
          borderRadius: '4px',
          height: '36px',
          color: 'var(--mui-palette-text-secondary)',
        }}
        name="selectFunc"
        displayEmpty
        value={props.value}
        onChange={event => {
          props.onChange(event.target.value);
        }}
        disableUnderline
        labelId="demo-simple-select-outlined-label"
        className="dropdown-mat selectStandard"
        variant="standard"
      >
        <MenuItem value="" disabled>
          {' '}
          Function{' '}
        </MenuItem>
        <MenuItem value={'contains'}> contains </MenuItem>
        <MenuItem value={'not_contains'}> does not contain </MenuItem>
        <MenuItem value={'matches'}> matches </MenuItem>
        <MenuItem value={'not_matches'}> does not match </MenuItem>
        <MenuItem value={'equal'}> equals </MenuItem>
        <MenuItem value={'not_equal'}> does not equal </MenuItem>
        <MenuItem value={'greater_than'}> greater than </MenuItem>
        <MenuItem value={'greater_than_or_equal'}> greater than or equal to </MenuItem>
        <MenuItem value={'less_than'}> less than </MenuItem>
        <MenuItem value={'less_than_or_equal'}> less than or equal to </MenuItem>
        <MenuItem value={'not_empty'}> is not empty </MenuItem>
        <MenuItem value={'empty'}> is empty </MenuItem>
      </Select>
    </React.Fragment>
  );
}

function SelectThenValue(props) {
  return (
    <React.Fragment>
      <Select
        // native
        style={{
          width: '100%',
          backgroundColor: 'var(--mui-palette-action-hover)',
          borderRadius: '4px',
          height: '36px',
          color: 'var(--mui-palette-text-secondary)',
        }}
        name="selectFunc"
        displayEmpty
        value={props.value}
        onChange={event => {
          props.onChange(event.target.value);
        }}
        disableUnderline
        labelId="demo-simple-select-outlined-label"
        className="dropdown-mat selectStandard"
        variant="standard"
      >
        <MenuItem value="" disabled>
          {' '}
          Select workflow{' '}
        </MenuItem>
        <MenuItem value={'continue'}>
          {' '}
          <Grid container direction={'row'} alignItems={'center'} columnGap={2}>
            {' '}
            <Start /> Continue the workflow{' '}
          </Grid>{' '}
        </MenuItem>
        <MenuItem value={'stop'}>
          {' '}
          <Grid container direction={'row'} alignItems={'center'} columnGap={2}>
            {' '}
            <Cancel /> Do not continue the workflow{' '}
          </Grid>{' '}
        </MenuItem>
      </Select>
    </React.Fragment>
  );
}

export { Logic, SelectFuc, OutputType, SelectThenValue };
